import { SharedBusinessCardSkeleton } from 'src/features/business/skeletons/shared-business-card-skeleton'
import { Button } from 'src/shared/components/ui/buttons/button'

const SharedBusinessSectionSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full flex-row items-center justify-between gap-4">
        <h1 className="text-[22px] font-semibold text-primary">Together on</h1>
        <Button variant="link" className="text-sm font-medium text-muted">
          View all
        </Button>
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
        <SharedBusinessCardSkeleton />
        <SharedBusinessCardSkeleton />
        <SharedBusinessCardSkeleton />
      </div>
    </div>
  )
}

export default SharedBusinessSectionSkeleton
